import { render, staticRenderFns } from "./Mdetail.vue?vue&type=template&id=329024f8&scoped=true"
import script from "./Mdetail.vue?vue&type=script&lang=js"
export * from "./Mdetail.vue?vue&type=script&lang=js"
import style0 from "./Mdetail.vue?vue&type=style&index=0&id=329024f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329024f8",
  null
  
)

export default component.exports